const COLORS = {
  paper: "#FBF6EA",
  espresso: "#3E2723",
  cognac2: "#A9682E",
  cognacLight: "#c98a45",
  gold: "#FFF2B0",
};

const fitFont = (ctx, text, weight, family, maxSize, maxWidth) => {
  let size = maxSize;
  while (size > 28) {
    ctx.font = `${weight} ${size}px "${family}"`;
    if (ctx.measureText(text).width <= maxWidth) break;
    size -= 2;
  }
  return size;
};

export async function downloadWerteBild(values) {
  await document.fonts.ready;
  await Promise.all([
    document.fonts.load('700 80px "Josefin Sans"'),
    document.fonts.load('600 40px "Josefin Sans"'),
    document.fonts.load('300 36px "Catamaran"'),
  ]).catch(() => {});

  const W = 1080;
  const H = 1920;
  const c = document.createElement("canvas");
  c.width = W;
  c.height = H;
  const ctx = c.getContext("2d");

  ctx.fillStyle = COLORS.paper;
  ctx.fillRect(0, 0, W, H);

  const bloom = ctx.createRadialGradient(W, 0, 100, W, 0, 900);
  bloom.addColorStop(0, "rgba(255,242,176,0.9)");
  bloom.addColorStop(1, "rgba(255,242,176,0)");
  ctx.fillStyle = bloom;
  ctx.fillRect(0, 0, W, H);

  ctx.textAlign = "center";
  ctx.fillStyle = COLORS.espresso;
  ctx.font = '700 34px "Josefin Sans"';
  ctx.fillText("L I M O N A T A   C O A C H I N G", W / 2, 160);

  ctx.fillStyle = COLORS.cognac2;
  ctx.font = '700 32px "Josefin Sans"';
  ctx.fillText("W E R   B I N   I C H ?", W / 2, 320);

  ctx.fillStyle = COLORS.espresso;
  ctx.font = '700 96px "Josefin Sans"';
  ctx.fillText("MEINE 4", W / 2, 440);
  ctx.fillText("KERNWERTE", W / 2, 550);

  const cardW = 760;
  const cardH = 210;
  const startY = 680;
  const gap = 250;
  values.forEach((v, i) => {
    const cx = W / 2;
    const cy = startY + i * gap + cardH / 2;
    ctx.save();
    ctx.translate(cx, cy);
    ctx.rotate((i % 2 ? 1.4 : -1.4) * (Math.PI / 180));
    ctx.shadowColor = "rgba(62,39,35,0.3)";
    ctx.shadowBlur = 40;
    ctx.shadowOffsetY = 18;
    ctx.fillStyle = COLORS.gold;
    ctx.beginPath();
    ctx.roundRect(-cardW / 2, -cardH / 2, cardW, cardH, 10);
    ctx.fill();
    ctx.shadowColor = "transparent";
    ctx.lineWidth = 4;
    ctx.strokeStyle = COLORS.cognac2;
    ctx.stroke();
    const text = v.toUpperCase();
    const size = fitFont(ctx, text, 700, "Josefin Sans", 64, cardW - 90);
    ctx.font = `700 ${size}px "Josefin Sans"`;
    ctx.fillStyle = COLORS.espresso;
    ctx.textBaseline = "middle";
    ctx.fillText(text, 0, 8);
    ctx.restore();
    ctx.textBaseline = "alphabetic";
  });

  ctx.fillStyle = COLORS.cognac2;
  ctx.font = '700 44px "Josefin Sans"';
  ctx.fillText("UNVERSCHÄMT ERFOLGREICH", W / 2, 1790);
  ctx.fillStyle = COLORS.espresso;
  ctx.font = 'italic 300 34px "Catamaran"';
  ctx.fillText("by Luisa Bergholz", W / 2, 1845);

  await new Promise((resolve) => {
    c.toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Meine-4-Kernwerte.png";
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
      resolve();
    }, "image/png");
  });
}
